import type { ClientPortalRedesignDecision } from '../hooks/use-client-portal-redesign';
import { shouldLandOnRedesignedHome } from './home-landing';

export type PortfolioSurface = 'pending' | 'accounts' | 'redesigned-home' | 'legacy-net-worth';

type PortfolioSurfaceInput = {
  readonly accountsDecision: ClientPortalRedesignDecision;
  readonly homeDecision: ClientPortalRedesignDecision;
  readonly role: string | null | undefined;
};

export function portfolioSurface({ accountsDecision, homeDecision, role }: PortfolioSurfaceInput): PortfolioSurface {
  if (accountsDecision === 'pending' || homeDecision === 'pending') {
    return 'pending';
  }
  if (accountsDecision === 'redesign') {
    return 'accounts';
  }
  if (shouldLandOnRedesignedHome({ homeRedesignEnabled: homeDecision === 'redesign', role })) {
    return 'redesigned-home';
  }
  return 'legacy-net-worth';
}
